import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit, output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription } from 'rxjs';

@Component({
  selector: 'spa-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TimeInputComponent),
    },
  ],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeInputComponent implements ControlValueAccessor, OnInit, OnDestroy {
  input: TimeInput | null = null;
  @Input() label = '';
  @Input() readonly = false;
  @Input() errorMessage: string | null = null;
  @Input() isRequired = false;

  customBlur = output<void>();

  limitLengthHour = 2;
  limitLengthMinute = 2;
  maximumHour = 23;
  maximumMinute = 59;

  formTimeInput = new FormGroup({
    hour: new FormControl<string | null>(null),
    minute: new FormControl<string | null>(null),
  });
  hourSubscription?: Subscription;
  minuteSubscription?: Subscription;
  isFocused = false;

  get hour() {
    return this.formTimeInput?.get('hour');
  }

  get minute() {
    return this.formTimeInput?.get('minute');
  }

  ngOnInit(): void {
    this.hourSubscription = this.hour?.valueChanges.subscribe(() => {
      this.updateValue();
    });

    this.minuteSubscription = this.minute?.valueChanges.subscribe(() => {
      this.updateValue();
    });

    /*const input = textInput.shadowRoot.querySelector("input");
    input.style.backgroundColor = "#..."*/
  }

  ngOnDestroy(): void {
    this.hourSubscription?.unsubscribe();
    this.minuteSubscription?.unsubscribe();
  }

  updateValue(): void {
    const hour = this.hour?.value || null;
    const minute = this.minute?.value || null;
    this.input = hour !== null || minute !== null ? { hour: hour ?? '', minute: minute ?? '' } : null;
    this.onChange(this.input);
  }

  onFocus() {
    this.isFocused = true;
  }

  onBlur(event: Event) {
    const currentTarget = event.currentTarget;
    const relatedTarget = (event as FocusEvent).relatedTarget;
    if (currentTarget instanceof Node && relatedTarget instanceof Node && currentTarget.contains(relatedTarget)) {
      return;
    }

    this.isFocused = false;
    this.customBlur.emit();
  }

  onChange: (obj: TimeInput | null) => void = () => {
    /** do nothing */
  };

  onTouched = () => {
    /** do nothing */
  };

  registerOnChange(fn: (obj: TimeInput | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(input: TimeInput): void {
    if (input != null) {
      this.input = input;
      this.formTimeInput.get('hour')?.setValue(input.hour);
      this.formTimeInput.get('minute')?.setValue(input.minute);
    }
  }
}

export interface TimeInput {
  hour: string;
  minute: string;
}
